'use strict';

angular.module('riskModule', [
    'governanceProcessModule',
    'boxTemplateModule'
]);